export default __webpack_public_path__ + "static/media/verifiedLine.dc1a37f6.svg";